export const environment = {
    production: true,
    hmr: false,
    mode: "PROD",
    dbPrefix: "",
    locationStrategy: "path",
    version: "storyhunt_home",
    // Always use frebase development DB even if we build to prod (optimized build)
    firebase: {
        apiKey: "AIzaSyAvHq7VHYsKisv0cZdccVFSMgdh5SJKKcU",
        authDomain: "motesdev.firebaseapp.com",
        databaseURL: "https://motesdev.firebaseio.com",
        projectId: "motesdev",
        storageBucket: "motesdev.appspot.com",
        messagingSenderId: "317816004740"
    },
    mapboxgl: {
        accessToken: "pk.eyJ1IjoiMTMzN3JhY2UiLCJhIjoiY2l0N2w3b2gyMDAxNDJwbWYycmUwbWZtdiJ9.w2EUUq-UP2rj8eqit4LsaQ"
    },
    googleAnalytics: {
        app: "UA-110095971-1",
        home: "UA-110095971-2",
        pro: "UA-110095971-3",
        cdn: "UA-110095971-4"
    },
    SUPABASE_URL: "https://apxpzzqzpidrhtyabdwv.supabase.co",
    SUPABASE_ANON_KEY: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFweHB6enF6cGlkcmh0eWFiZHd2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE2OTEwODMwODQsImV4cCI6MjAwNjY1OTA4NH0.Ao_p2hqOLZgAEF7-N3oZYGUrPtyeNOefuJba9u6iYoM",
    STORYHUNT_LRP_API: "https://lrp.storyhunt.io/v1"
};
